import { getPersonalAddresses, removePersonalAddress, setPersonalAddressToForm } from './personal-addresses.js';
import { calculateOrderPrice } from './deliveryOrder.js';
import { dispatchOrderValidate } from './orderValidation.js';

export function initPersonalAddressesDropdown() {
    const deliveryDropdowns = document.querySelectorAll('.item-delivery .dropdown');
    const personalAddressesDropdown = deliveryDropdowns[0]; // Первый dropdown - для личных адресов
    
    if (!personalAddressesDropdown) {
        return;
    }
    
    const dropdownBody = personalAddressesDropdown.querySelector('.dropdown__body');
    const dropdownHeader = personalAddressesDropdown.querySelector('.dropdown__header__text');
    
    if (!dropdownBody || !dropdownHeader) {
        return;
    }
    
    function updateDropdownContent() {
        const savedAddresses = getPersonalAddresses();
        
        const sortedAddresses = savedAddresses.sort((a, b) => 
            new Date(b.createdAt) - new Date(a.createdAt)
        );
        
        dropdownBody.innerHTML = '';
        
        if (sortedAddresses.length === 0) {
            const emptyMessage = document.createElement('div');
            emptyMessage.className = 'dropdown__item dropdown__item__empty';
            emptyMessage.innerHTML = `
                <div class="dropdown__item__text">
                    <div class="dropdown__item__title">Нет сохраненных адресов</div>
                    <div class="dropdown__item__subtitle">Добавьте адрес через форму, чтобы сохранить его</div>
                </div>
            `;
            dropdownBody.appendChild(emptyMessage);
        } else {
            sortedAddresses.forEach((address, index) => {
                const addressElement = document.createElement('div');
                addressElement.className = 'dropdown__item';
                addressElement.dataset.addressId = address.id;
                addressElement.dataset.city = address.city;
                addressElement.dataset.address = address.fullAddress;
                
                const createdDate = new Date(address.createdAt).toLocaleDateString('ru-RU', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                
                addressElement.innerHTML = `
                    <div class="dropdown__item__text">
                        <div class="dropdown__item__subtitle">${address.fullAddress}</div>
                    </div>
                `;
                
                addressElement.addEventListener('click', (e) => {
                    if (!e.target.closest('.dropdown__item__remove')) {
                        selectPersonalAddress(address);
                    }
                });
                
                dropdownBody.appendChild(addressElement);
            });
        }
    }
    
    // Функция для выбора личного адреса
    function selectPersonalAddress(address) {
        console.log('Выбран личный адрес:', address);
        
        // Обновляем заголовок dropdown
        dropdownHeader.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                <path d="M11.2111 1.65423C10.5179 1.03951 9.70243 0.57837 8.81834 0.301094C7.93425 0.0238169 7.00151 -0.0633302 6.08135 0.045374C4.46691 0.273565 2.99193 1.08509 1.93505 2.32666C0.878168 3.56823 0.312561 5.15386 0.345078 6.78402C0.355587 8.41038 0.953941 9.97807 2.02974 11.1978L5.78653 15.4937C5.9249 15.6527 6.09575 15.7801 6.28755 15.8675C6.47936 15.9548 6.68766 16 6.89841 16C7.10916 16 7.31746 15.9548 7.50927 15.8675C7.70107 15.7801 7.87192 15.6527 8.01029 15.4937L11.7671 11.1978C12.8429 9.97807 13.4412 8.41038 13.4517 6.78402V6.53132C13.4447 5.60612 13.2414 4.69295 12.8551 3.8522C12.4689 3.01145 11.9085 2.26228 11.2111 1.65423ZM12.1377 6.7756C12.1388 8.0931 11.6597 9.36584 10.79 10.3555L7.03318 14.6598C6.92368 14.7777 6.8226 14.7862 6.7131 14.6598L2.9563 10.3555C2.0866 9.36584 1.60745 8.0931 1.60857 6.7756C1.57642 5.45534 2.02925 4.16908 2.8814 3.16016C3.73356 2.15123 4.92594 1.4896 6.23297 1.30045C6.44899 1.28786 6.66555 1.28786 6.88157 1.30045C8.26986 1.30484 9.60042 1.85656 10.5845 2.83587C11.5685 3.81518 12.1266 5.14306 12.1377 6.53132V6.7756Z" fill="#414141" fill-opacity="0.56"/>
                <path d="M6.87261 3.37207C6.24787 3.37207 5.63716 3.55733 5.11771 3.90441C4.59826 4.2515 4.19339 4.74483 3.95431 5.32201C3.71524 5.8992 3.65268 6.53432 3.77456 7.14705C3.89644 7.75979 4.19728 8.32262 4.63904 8.76438C5.0808 9.20614 5.64363 9.50698 6.25637 9.62886C6.86911 9.75074 7.50422 9.68818 8.08141 9.44911C8.65859 9.21003 9.15192 8.80517 9.49901 8.28571C9.84609 7.76626 10.0314 7.15555 10.0314 6.53081C10.0314 5.69306 9.69856 4.88962 9.10618 4.29724C8.5138 3.70487 7.71036 3.37207 6.87261 3.37207ZM6.87261 8.42606C6.49777 8.42606 6.13134 8.3149 5.81967 8.10665C5.508 7.8984 5.26508 7.6024 5.12163 7.25609C4.97819 6.90978 4.94065 6.52871 5.01378 6.16107C5.08691 5.79343 5.26741 5.45573 5.53247 5.19067C5.79752 4.92562 6.13522 4.74511 6.50287 4.67198C6.87051 4.59885 7.25158 4.63639 7.59789 4.77983C7.9442 4.92328 8.2402 5.1662 8.44845 5.47787C8.6567 5.78954 8.76785 6.15597 8.76785 6.53081C8.76785 7.03346 8.56818 7.51552 8.21275 7.87095C7.85732 8.22638 7.37526 8.42606 6.87261 8.42606Z" fill="#414141" fill-opacity="0.56"/>
            </svg>
            ${address.city} - ${address.fullAddress}
        `;
        
        // Обновляем форму заказа
        const orderForm = document.querySelector('#order-form');
        if (orderForm) {
            orderForm.dataset.city_name = address.city;
            orderForm.dataset.personal_address = address.id;
        }
        
        // Устанавливаем адрес в форму доставки
        setPersonalAddressToForm(address);
        
        // Пересчитываем цену доставки (используем тариф для курьерской доставки)
        calculateOrderPrice(address.city, '137');
        
        // Запускаем валидацию формы
        dispatchOrderValidate();
        
        // Закрываем dropdown с небольшой задержкой для лучшего UX
        setTimeout(() => {
            dropdownBody.classList.add('none');
            
            // Также закрываем все остальные dropdowns для консистентности
            if (window.closeAllOtherDropdowns) {
                window.closeAllOtherDropdowns();
            } else {
                const allDropdowns = document.querySelectorAll('.dropdown .dropdown__body');
                allDropdowns.forEach(dropdown => {
                    if (dropdown !== dropdownBody) {
                        dropdown.classList.add('none');
                    }
                });
            }
        }, 150);
    }
    
    // Глобальная функция для удаления адреса из dropdown
    window.removePersonalAddressFromDropdown = function(addressId) {
        removePersonalAddress(addressId);
        updateDropdownContent();
        console.log(`Адрес ${addressId} удален из dropdown`);
    };
    
    // Инициализируем содержимое dropdown при загрузке
    updateDropdownContent();
    
    // Обновляем dropdown при изменении сохраненных адресов
    window.updatePersonalAddressesDropdown = updateDropdownContent;
    
    console.log('✅ Dropdown личных адресов инициализирован');
}

// Функция для добавления нового адреса в dropdown
export function addPersonalAddressToDropdown(addressData) {
    // Обновляем dropdown если он инициализирован
    if (window.updatePersonalAddressesDropdown) {
        window.updatePersonalAddressesDropdown();
    }
    
    console.log('Новый личный адрес добавлен в dropdown:', addressData);
}

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    // Ждем немного, чтобы все элементы загрузились
    setTimeout(() => {
        initPersonalAddressesDropdown();
    }, 100);
}); 